document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);
  }
  initPremiumBestSellers();
});

document.addEventListener("shopify:section:load", function (e) {
  initPremiumBestSellers();
});

function initPremiumBestSellers() {
  const section = document.querySelector(".bs-reveal-section");
  if (!section) return;

  const headings = section.querySelectorAll(".animate-fade-in");
  const cards = section.querySelectorAll(".animate-card");
  const viewAllBtn = section.querySelector(".bs-view-all-btn");

  // 1. Initial Page Load / On-Scroll Section Entrance Sequence
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });

  tl.fromTo(headings, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" });
  tl.fromTo(cards, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: "power3.out" }, "-=0.3");
  tl.fromTo(section.querySelector(".bs-view-all-wrapper"), { opacity: 0, y: 15 }, { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" }, "-=0.4");

  // 2. Exact Two-Way Reversible Fill Hover Timeline for the Bottom View All Button
  if (viewAllBtn) {
    const btnBg = viewAllBtn.querySelector(".bs-btn-bg");
    const btnText = viewAllBtn.querySelector("span");

    // Pre-build execution paths for perfect forwards/backwards animation match
    const hoverTl = gsap.timeline({ paused: true });
    
    hoverTl.to(btnBg, {
      height: "100%",
      duration: 0.35,
      ease: "power2.out"
    }, 0)
    .to(btnText, {
      color: "#faf6f0",
      duration: 0.25
    }, 0);

    viewAllBtn.addEventListener("mouseenter", () => hoverTl.play());
    viewAllBtn.addEventListener("mouseleave", () => hoverTl.reverse());
  }

  // 3. Card Micro-Interactions Hover Loop Mechanics
  cards.forEach((card) => {
    const img = card.querySelector(".bs-img");
    const infoBox = card.querySelector(".bs-info-box");
    const cartBtn = card.querySelector(".bs-add-form");

    card.addEventListener("mouseenter", () => {
      // Background Image Blur & Zoom
      gsap.to(img, { filter: "blur(6px)", scale: 1.05, duration: 0.45, ease: "power2.out" });
      // Slide up information card panel
      gsap.to(infoBox, { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" });

      // Pop in the cart action icon
      if (cartBtn && window.innerWidth > 576) {
        gsap.to(cartBtn, { opacity: 1, scale: 1, duration: 0.35, ease: "back.out(1.5)" });
      }
    });

    card.addEventListener("mouseleave", () => {
      // Reset image properties safely
      gsap.to(img, { filter: "blur(0px)", scale: 1, duration: 0.4, ease: "power2.out" });
      // Hide information card panel
      gsap.to(infoBox, { opacity: 0, y: 15, duration: 0.3, ease: "power2.in" });

      // Hide cart icon
      if (cartBtn && window.innerWidth > 576) {
        gsap.to(cartBtn, { opacity: 0, scale: 0.7, duration: 0.25, ease: "power2.in" });
      }
    });
  });
}